import React from "react"
import "./Checkboxes.css"

export default function Radiobuttons(params) {

    const {values, selected, onChange} = params
        
    const onClick = (event) => {
        const newValue = event.target.dataset.value
        if (newValue !== selected)
            onChange(newValue)
    }
        
    return <div className="checkboxes">
        {values?.map(value => <label key={value} className="gss-checkbox">
            <input type="radio" data-value={value} checked={selected === value} onChange={onClick}/>
            <span className="btn btn-primary btn-sm">{value}</span>
        </label>)}
    </div>
}